/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Driver_Start_Trip_HintInputs */

const vi_dashboard_driver_start_trip_hint = /** @type {(inputs: Dashboard_Driver_Start_Trip_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhận đơn và bắt đầu chuyến mới`)
};

/**

* @param {Dashboard_Driver_Start_Trip_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_driver_start_trip_hint = /** @type {((inputs?: Dashboard_Driver_Start_Trip_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Driver_Start_Trip_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_driver_start_trip_hint(inputs)
});